export const menuItems = [
  {
    title: "Home",
    links: [
      { label: "Benefits", path: "/" },
      { label: "Testimonials", path: "/" },
      { label: "Our Partners", path: "/" },
    ],
  },
  {
    title: "Services",
    links: [
      { label: "Web Design", path: "/services" },
      { label: "Website Development", path: "/services" },
      { label: "App Development", path: "/services" },
      { label: "Digital Marketing", path: "/services" },
    ],
  },
  {
    title: "About Us",
    links: [
      { label: "Our Team", path: "/about" },
      { label: "Achievements", path: "/about" },
      { label: "Awards", path: "/about" },
    ],
  },
  {
    title: "Careers",
    links: [
      { label: "Job Openings", path: "/career" },
      { label: "Benefits & Perks", path: "/career" },
      { label: "Employee Referral", path: "/career" },
    ],
  },
  // {
  //   title: "Blog",
  //   links: [
  //     { label: "Our Blog", path: "/blog" },
  //     { label: "Tech Insights", path: "/blog/tech" },
  //     { label: "Company News", path: "/blog/news" },
  //   ],
  // },
];
